import axios from 'axios'

import { currencies } from '../constants'

const services = {
  getReturnPortalConfig: ({ slug }) => axios.get(`${import.meta.env.VITE_HOST}/portals/${slug?.toLowerCase()}`),
  getStores: () => axios.get(`${import.meta.env.VITE_HOST}/stores`),
  getOrder: payload => axios.post(`${import.meta.env.VITE_HOST}/orders/check`, payload),
  requestOrderRecoveryLink: payload => axios.post(`${import.meta.env.VITE_HOST}/orders/recovery-link`, payload),
  getRecoverableOrders: () => axios.get(`${import.meta.env.VITE_HOST}/orders/recoverable`),
  getSessionMonitoringAuth: payload => axios.post(`${import.meta.env.VITE_HOST}/session-events/auth`, payload),
  getBankAccounts: ({ type = 'EUR' }) =>
    axios.get(`${import.meta.env.VITE_HOST}/me/payment-methods`, {
      params: { type: type === currencies.GBP ? 'UK' : 'IBAN' },
    }),
  createReturn: ({ returnInfo, orderId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns`, returnInfo),
  getReturnPreview: ({ payload, orderId }, config) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/preview`, payload, config),
  sendValidationCode: ({ uuid, code, paymentMethodId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/me/emails/${uuid}/verify`, { code, payment_method_id: paymentMethodId }),
  resendVerifyEmail: ({ uuid, email }) =>
    axios.post(`${import.meta.env.VITE_HOST}/me/emails/${uuid}/resend-verification`, { email }),
  createBankAccount: payload => axios.post(`${import.meta.env.VITE_HOST}/me/payment-methods`, payload),
  getToken: ({ email, password }) => axios.post(`${import.meta.env.VITE_HOST}/token`, { email, password }),
  getEmails: () => axios.get(`${import.meta.env.VITE_HOST}/me/emails`),
  addEmail: ({ email }) => axios.post(`${import.meta.env.VITE_HOST}/me/emails`, { email }),
  sendScore: ({ score, orderId, returnId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/score`, { score }),
  restorePassword: ({ email }) => axios.post(`${import.meta.env.VITE_HOST}/reset-password`, { email }),
  completeReturn: ({ payload, orderId, returnId }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/complete`, payload),
  getReturn: ({ orderId, returnId }) => axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}`),
  getDeliveryMethods: ({ orderId, returnId, regionId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/delivery-methods`, {
      params: { region_id: regionId },
    }),
  getServicePoints: ({ orderId, returnId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/service-points`, { params }),
  sendUserEvents: events => axios.post(`${import.meta.env.VITE_DATA_HOST}/return-events`, events),
  uploadProductImage: (orderId, formData) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/image`, formData),
  setRefundMethod: ({ orderId, returnId, refundMethod }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/refund-method`, {
      method: refundMethod,
    }),
  getRecommendedExchangeProducts: ({ orderId, itemId, page = 1 }) =>
    axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/line-items/${itemId}/recommended-exchange-products`, {
      params: { page },
    }),
  searchProducts: ({ storeId, search, page, lineItemId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products`, {
      params: { search, page, line_item_id: lineItemId },
    }),
  getVariantsByProduct: ({ storeId, productId, lineItemId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/${productId}/variants`, {
      params: {
        line_item_id: lineItemId,
      },
    }),
  addDeliveryMethodToReturn: ({ orderId, returnId, payload }) =>
    axios.put(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/delivery-method`, payload),
  validateAddress: ({ orderId, returnId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/validate-address`, payload),
  updateShippingAddress: ({ orderId, returnId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/shipping-address`, payload),
  getRecommendedExchangeVariants: ({ orderId, lineItemId, reasonId }) =>
    axios.post(
      `${import.meta.env.VITE_HOST}/orders/${orderId}/line-items/${lineItemId}/recommended-exchange-variants`,
      {
        reason_id: reasonId,
      }
    ),
  getReturnReasons: ({ storeId, returnPortalId, productId, lineItemId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/${productId}/return-reasons`, {
      params: {
        line_item_id: lineItemId,
        portal_id: returnPortalId,
      },
    }),
  getAvailableOrders: ({ storeId }) => axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/orders`),
  getProductsTaxonomy: ({ storeId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/exchange-products-taxonomy`),
  getProductsByTaxonomy: ({ storeId, taxonomy, taxonomyValue, page, lineItemId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products`, {
      params: { [taxonomy]: taxonomyValue, page, line_item_id: lineItemId },
    }),
  assignReturnToGroup: ({ orderId, returnId, inGroup }) =>
    axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/group`, { in_group: inGroup }),
  getEstimatedDeliveryMethods: ({ orderId, params }) =>
    axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/delivery-methods`, { params }),
}

export default services
